import { Search, ChevronLeft, ChevronRight } from "lucide-react";

export function SearchInput({ value, onChange, placeholder, testId }) {
  return (
    <div className="relative w-full max-w-xs">
      <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#89919a]" />
      <input
        data-testid={testId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder || "Search…"}
        className="w-full rounded-md border border-[#c8cfda] bg-white py-2 pl-9 pr-3 text-sm text-[#32363a] outline-none focus:border-[#0a6ed1]"
      />
    </div>
  );
}

export function Pager({ page, pages, total, pageSize = 50, onPage, testId }) {
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(total, page * pageSize);
  const btn = "inline-flex items-center justify-center rounded-md border border-[#c8cfda] bg-white p-1.5 text-[#32363a] transition hover:border-[#0a6ed1] disabled:cursor-not-allowed disabled:opacity-40";
  return (
    <div className="mt-3 flex items-center justify-between text-xs text-[#6a6d70]" data-testid={testId}>
      <span data-testid="pager-range">{from.toLocaleString()}–{to.toLocaleString()} of {total.toLocaleString()}</span>
      <div className="flex items-center gap-3">
        <button data-testid="pager-prev" className={btn} disabled={page <= 1} onClick={() => onPage(page - 1)}>
          <ChevronLeft size={16} />
        </button>
        <span className="font-mono">Page {page} / {pages}</span>
        <button data-testid="pager-next" className={btn} disabled={page >= pages} onClick={() => onPage(page + 1)}>
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
}
